import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Segment, Icon, Label, Button, Message, Modal, Container } from 'semantic-ui-react'

import DataTable from '../../components/DataTable'

const propTypes = {
  auditResult: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
}

const defaultProps = {
  auditResult: {},
  open: false,
}

class SystemAuditResultModal extends Component {
  render() {
    const { auditResult, open, onClose } = this.props

    const duplicateArticles = _.get(auditResult, 'duplicateArticles', null)

    return (
      <Modal
        className="SystemAuditResultModal"
        size="large"
        closeIcon
        open={open}
        onClose={onClose}
        closeOnDimmerClick={false}
      >
        <Modal.Header>重複チェック結果</Modal.Header>

        <Modal.Content>
          <Segment>
            <Label attached="top" color="blue" content="重複記事一覧" />

            {_.isEmpty(duplicateArticles) ? (
              <Message info>重複した記事は見つかりませんでした</Message>
            ) : (
              <DataTable
                rowKey="id"
                items={duplicateArticles}
                columns={[
                  {
                    label: '記事ID',
                    field: 'id',
                    align: 'center',
                    minWidth: '5em',
                    render: item => {
                      const articleId = _.get(item, 'id', '')

                      return (
                        <a href={`/article/${articleId}`} target="_blank" rel="noopener noreferrer">
                          {articleId} <Icon name="external" />
                        </a>
                      )
                    },
                  },
                  {
                    label: 'タイトルの類似度',
                    field: 'titleSimilarity',
                    align: 'center',
                    render: item => {
                      const similarity = _.round(_.min([_.get(item, 'titleSimilarity', 0) * 100, 100]) * 100) / 100

                      return <b>{`${similarity}%`}</b>
                    },
                  },
                  {
                    label: '本文の類似度',
                    field: 'descriptionSimilarity',
                    align: 'center',
                    render: item => {
                      const similarity =
                        _.round(_.min([_.get(item, 'descriptionSimilarity', 0) * 100, 100]) * 100) / 100

                      return <b>{`${similarity}%`}</b>
                    },
                  },
                ]}
              />
            )}
          </Segment>
        </Modal.Content>

        <Modal.Actions>
          <Button content="閉じる" onClick={onClose} />
        </Modal.Actions>
      </Modal>
    )
  }
}

SystemAuditResultModal.propTypes = propTypes
SystemAuditResultModal.defaultProps = defaultProps

export default SystemAuditResultModal
